export default {
    name: 'cultures',
    serverName: '/api/v1/culture/culture/',
    apiUrl: '/api/v1/culture/culture/'
};
